module.exports = __webpack_public_path__ + "static/trees-3.3-5881b1f19a78801e50b6d10de1aa7842.png";